import { get } from '@/api/Services'
import { createRouter, createWebHistory } from 'vue-router'
import { getItem } from '@/store/localStorage'
import { account } from '@/store/account.module'
import PersonalBillingInfo from './pages/PersonalBillingInfo.vue'

// Create a global event bus for loading state
import mitt from 'mitt'
export const loadingEventBus = mitt()

const checkLink = (to, from, next) => {
  // Eğer kullanıcı oturum açmamışsa, login sayfasına yönlendir
  if (!account.state.loggeduser) {
    return next({ name: 'login' })
  }

  // Menüdeki linke sahip olan rotayı bulalım
  const userMenu = account.state.userMenu || getItem('userMenu')

  // userMenu'nin bir dizi olup olmadığını kontrol et
  if (Array.isArray(userMenu)) {
    const menuItem = userMenu.find((item) => item.link === to.path)
    // Eğer link varsa rotaya izin ver, yoksa notFound sayfasına yönlendir
    if (menuItem && menuItem.link) {
      next()
    } else {
      next({ name: 'unauthorized' })
    }
  } else {
    // userMenu bir dizi değilse veya bulunamıyorsa notFound sayfasına yönlendir
    next({ name: 'notFound' })
  }
}

const redirectIfAuthenticated = (to, from, next) => {
  if (account.state.loggeduser) {
    return next(from)
  }
  next() // Devam et
}

const routes = [
  {
    path: '/chrs',
    name: 'chrs',
    component: () => import('@/components/Dashboard.vue'),
    meta: { requiresAuth: true },
    beforeEnter: checkLink,
  },
  {
    path: '/get-started',
    name: 'getStarted',
    component: () => import('@/pages/GetStarted.vue'),
    beforeEnter: redirectIfAuthenticated, // Sayfaya girmeden önce kontrol
  },
  {
    path: '/chrs/profile',
    name: 'profile',
    component: () => import('@/pages/User/Profile.vue'),
    meta: { requiresAuth: true },
    beforeEnter: checkLink,
  },
  {
    path: '/profile/:encryptedId',
    name: 'publicProfile',
    component: () => import('@/pages/User/PublicProfile.vue'),
    props: true,
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/pages/Login.vue'),
    beforeEnter: redirectIfAuthenticated, // Sayfaya girmeden önce kontrol
    props: true, // props ile parametreleri bileşene geçirirsiniz
  },
  {
    path: '/',
    name: 'home',
    component: () => import('@/pages/Home.vue'),
  },
  {
    path: '/for-recruiters',
    name: 'home-recruiters',
    component: () => import('@/pages/HomeRecruiters.vue'),
  },
  {
    path: '/for-companies',
    name: 'home-companies',
    component: () => import('@/pages/HomeCompany.vue'),
  },
  {
    path: '/for-candidates',
    name: 'home-candidates',
    component: () => import('@/pages/HomeCandidates.vue'),
  },
  {
    path: '/job-detail/:name/:id',
    name: 'jobDetail',
    component: () => import('@/pages/JobDetail.vue'),
  },
  {
    path: '/signup',
    name: 'signUp',
    component: () => import('@/pages/Signup.vue'),
    beforeEnter: redirectIfAuthenticated, // Sayfaya girmeden önce kontrol
  },
  {
    path: '/chrs/candidate-status',
    name: 'candidateStatus',
    component: () => import('@/pages/Definitions/CandidateStatus.vue'),
    meta: { requiresAuth: true },
    beforeEnter: checkLink,
  },
  {
    path: '/chrs/education-level',
    name: 'educationLevel',
    component: () => import('@/pages/Definitions/EducationLevel.vue'),
    meta: { requiresAuth: true },
    beforeEnter: checkLink,
  },
  {
    path: '/chrs/job-types',
    name: 'jobTypes',
    component: () => import('@/pages/Definitions/jobTypes.vue'),
    meta: { requiresAuth: true },
    beforeEnter: checkLink,
  },
  {
    path: '/chrs/job-status',
    name: 'jobStatus',
    component: () => import('@/pages/Definitions/JobStatus.vue'),
    meta: { requiresAuth: true },
    beforeEnter: checkLink,
  },
  {
    path: '/chrs/job-industries',
    name: 'jobIndustries',
    component: () => import('@/pages/Definitions/JobIndustries.vue'),
    meta: { requiresAuth: true },
    beforeEnter: checkLink,
  },
  {
    path: '/chrs/job-salary',
    name: 'jobSalary',
    component: () => import('@/pages/Definitions/JobSalary.vue'),
    meta: { requiresAuth: true },
    beforeEnter: checkLink,
  },
  {
    path: '/chrs/job-location',
    name: 'jobLocation',
    component: () => import('@/pages/Definitions/JobLocation.vue'),
    meta: { requiresAuth: true },
    beforeEnter: checkLink,
  },
  {
    path: '/chrs/users',
    name: 'users',
    component: () => import('@/pages/Users/UserList.vue'),
    meta: { requiresAuth: true },
    beforeEnter: checkLink,
  },
  {
    path: '/chrs/companies',
    name: 'companies',
    component: () => import('@/pages/Companies/CompanyList.vue'),
    meta: { requiresAuth: true },
    beforeEnter: checkLink,
  },
  {
    path: '/chrs/companies/create',
    name: 'companiesCreate',
    component: () => import('@/pages/Companies/CompanyCreate.vue'),
    meta: { requiresAuth: true },
    beforeEnter: checkLink,
  },
  {
    path: '/chrs/companies/edit/:id',
    name: 'companiesEdit',
    component: () => import('@/pages/Companies/CompanyEdit.vue'),
    meta: { requiresAuth: true },
    //beforeEnter: checkLink,
    props: true,
  },
  {
    path: '/jobs',
    name: 'jobs',
    component: () => import('@/pages/JobList.vue'),
  },
  {
    path: '/chrs/job-openings',
    name: 'jobOpenings',
    component: () => import('@/pages/Jobs/JobOpenings.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/chrs/jobs/create',
    name: 'jobsCreate',
    component: () => import('@/pages/Jobs/CreateNewJob.vue'),
    meta: { requiresAuth: true },
    beforeEnter: checkLink,
  },
  {
    path: '/chrs/jobs/edit',
    name: 'jobsEdit',
    component: () => import('@/pages/Jobs/UpdateJob.vue'),
    meta: { requiresAuth: true },
    beforeEnter: checkLink,
  },
  {
    path: '/chrs/candidates',
    name: 'candidates',
    component: () => import('@/pages/Candidates/CandidateList.vue'),
    meta: { requiresAuth: true },
    beforeEnter: checkLink,
  },
  {
    path: '/chrs/applications',
    name: 'applications',
    component: () => import('@/pages/Jobs/Application.vue'),
    meta: { requiresAuth: true },
    beforeEnter: checkLink,
  },
  {
    path: '/chrs/application-history/:jobId/:candidateId?',
    name: 'applicationHistory',
    component: () => import('@/pages/chrs/application-history.vue'),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/chrs/candidate-history/:userId/:candidateId?',
    name: 'candidateHistory',
    component: () => import('@/pages/chrs/candidate-history.vue'),
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/chrs/candidate-edit/:id',
    name: 'candidateEdit',
    component: () => import('@/pages/Candidates/CandidateEdit.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/chrs/candidate-new',
    name: 'newCandidate',
    component: () => import('@/pages/Candidates/CandidateNew.vue'),
    meta: { requiresAuth: true },
    beforeEnter: checkLink,
  },
  {
    path: '/company-signup',
    name: 'companySignup',
    component: () => import('@/pages/CompanySignup.vue'),
    beforeEnter: redirectIfAuthenticated, // Sayfaya girmeden önce kontrol
  },
  {
    path: '/chrs/recruiter-payments',
    name: 'recruiterPayments',
    component: () => import('@/pages/chrs/recruiter-payments.vue'),
    meta: { requiresAuth: true },
    //beforeEnter: checkLink,
  },
  {
    path: '/chrs/payment-entry',
    name: 'paymentEntry',
    component: () => import('@/pages/chrs/payment-entry.vue'),
    meta: { requiresAuth: true },
    //beforeEnter: checkLink,
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: () => import('@/pages/ResetPassword.vue'),
  },
  {
    path: '/chrs/change-password',
    name: 'changePassword',
    component: () => import('@/components/profile/ChangePassword.vue'),
  },
  {
    path: '/confirm-email',
    name: 'confirmEmail',
    component: () => import('@/pages/MailConfirmation.vue'),
  },
  {
    path: '/payment-success',
    name: 'paymentSuccess',
    component: () => import('@/pages/PaymentSuccess.vue'),
  },
  {
    path: '/payment-failed',
    name: 'paymentFailed',
    component: () => import('@/pages/PaymentFailed.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: () => import('@/pages/NotFound.vue'),
  },
  {
    path: '/unauthorized',
    name: 'unauthorized',
    component: () => import('@/pages/Unauthorized.vue'),
  },
  {
    path: '/messages',
    name: 'messages',
    component: () => import('@/pages/Messages.vue'),
  },
  {
    path: '/linkedin/callback',
    name: 'linkedinCallback',
    component: () => import('@/pages/linkedin-callback.vue'),
  },
  {
    path: '/chrs/billing-plan',
    name: 'billing-plan',
    component: () => import('@/pages/invoiceAndPayments.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/chrs/recruiter-billing-history',
    name: 'recruiter-history',
    component: () => import('@/pages/RecruiterHistory.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/chrs/billing-history',
    name: 'billing-history',
    component: () => import('@/pages/MyBillingHistory.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/chrs/checkout',
    name: 'checkout',
    component: () => import('@/pages/Checkout.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import('@/pages/Faq.vue'),
  },
  {
    path: '/privacy-policy',
    name: 'privacyPolicy',
    component: () => import('@/pages/PrivacyPolicy.vue'),
  },
  {
    path: '/terms-of-service',
    name: 'termsOfService',
    component: () => import('@/pages/TermsOfService.vue'),
  },
  {
    path: '/about-us',
    name: 'about',
    component: () => import('@/pages/About.vue'),
  },
  {
    path: '/contact-us',
    name: 'contactUs',
    component: () => import('@/pages/ContactUs.vue'),
  },
  {
    path: '/chrs/company-billing-info',
    name: 'billingDetail',
    component: () => import('@/pages/BillingDetail.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: '/how-it-works',
    name: 'howItWorks',
    component: () => import('@/pages/HowItWorks.vue'),
  },
  {
    path: '/chrs/personal-billing-info',
    name: 'PersonalBillingInfo',
    component: PersonalBillingInfo,
    meta: {
      requiresAuth: true,
    },
  },
]

// Define scroll behavior
const scrollBehavior = () => ({ top: 0 })

async function fetchUserRole() {
  await get('Users/Role').then()
}
function isValidName(name) {
  // İsim doğrulama mantığınızı buraya ekleyin
  return typeof name === 'string' && name.length > 0
}

function isValidId(id) {
  // ID doğrulama mantığınızı buraya ekleyin
  return Number.isInteger(parseInt(id, 10)) && parseInt(id, 10) > 0
}

// Create router instance
export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior,
})

// Define route guard
router.beforeEach(async (to, from, next) => {
  // Skip loading for login, signup, and company-signup routes
  const noLoadingRoutes = ['/login', '/signup', '/company-signup']
  const shouldShowLoading = !noLoadingRoutes.includes(to.path)

  // Don't show loading spinner for initial page load or specified routes
  if (from.name !== null && shouldShowLoading) {
    // Show loading spinner only for page transitions, not initial load
    loadingEventBus.emit('loading', true)
  }

  const stateUser = account.state.loggeduser
  const localUser = getItem('loggeduser')

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!stateUser && !localUser) {
      loadingEventBus.emit('loading', false) // Hide loading spinner before redirect
      return next({ path: '/login', query: { redirect: to.fullPath } })
    }
    await fetchUserRole()
  }

  // If it's a simple navigation without auth requirements, proceed quickly
  if (!to.matched.some((record) => record.meta.requiresAuth)) {
    next()
    return
  }

  next()
})

// Hide loading spinner after navigation is complete
router.afterEach(() => {
  // Use requestAnimationFrame for smoother transitions
  requestAnimationFrame(() => {
    setTimeout(() => {
      loadingEventBus.emit('loading', false)
    }, 100)
  })
})

// Handle navigation errors
router.onError(() => {
  // Hide loading spinner immediately in case of navigation errors
  loadingEventBus.emit('loading', false)
})

export default router
